import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Typography, useOverlayContext } from 'seagull';
import BillClientModal from '~/components/BillClientModal/BillClientModal';
import { billingStagesTextsPath } from '~/components/BillClientModal/v2/shared/Lines/lineItem.utils';
import { useLocaleKeys } from '~/i18n';
import { Intent } from '~/infra/access-control';
import { currencyUtils } from '~/utils/currency.utils';
import { nonBillableReasonToTooltip } from '../../BillingControl.utils';
import styles from '../../ServicesSection.module.scss';
import ServiceTitle from '../ServiceTitle';
import { getLastBilledStageServiceItem } from './ManualInStagesBillingItem.utils';
import RemainingStages from './RemainingStages';
export default function ManualInStagesBillingItem(props) {
    const { idx, name, service, qboItemName, xeroItemName, qboClassName, costDisplay, controlData, invoiceDateInfo, agreementId, earliestBillableDate } = props;
    const overlayContext = useOverlayContext();
    const { t } = useLocaleKeys(billingStagesTextsPath);
    const serviceId = service.id;
    const totalCredits = controlData.getTotalCredits();
    const billingStages = controlData.getManualServiceBillingStages(service.id);
    const manualServices = controlData.getManualServices();
    const nonBillableReason = controlData.getNonBillableReason(service.id);
    const alreadyBilledAmount = controlData.getAlreadyBilledAmount(service.id);
    const lastBilledStageServiceItem = getLastBilledStageServiceItem({
        service,
        billingStages,
        t
    });
    return /*#__PURE__*/ _jsxs("li", {
        "data-testid": "service-".concat(idx),
        className: styles.serviceBox,
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: styles.serviceDescription,
                children: [
                    /*#__PURE__*/ _jsx(ServiceTitle, {
                        name: name,
                        serviceId: serviceId,
                        qboItemName: qboItemName,
                        xeroItemName: xeroItemName,
                        qboClassName: qboClassName
                    }),
                    /*#__PURE__*/ _jsx("div", {
                        className: styles.cost,
                        children: /*#__PURE__*/ _jsx(Typography, {
                            testId: "cost",
                            variant: "paragraph2",
                            skin: "secondary",
                            children: costDisplay
                        })
                    }),
                    /*#__PURE__*/ _jsxs(Typography, {
                        testId: "already-billed-amount",
                        variant: "paragraph2",
                        skin: "secondary",
                        children: [
                            "Already billed: ",
                            currencyUtils.formatDollarAmount(alreadyBilledAmount)
                        ]
                    }),
                    /*#__PURE__*/ _jsx(RemainingStages, {
                        billingStages: billingStages,
                        service: service
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.lineItemAction,
                children: /*#__PURE__*/ _jsx(Button, {
                    bi: {
                        name: 'bill_stage'
                    },
                    size: "small",
                    intent: Intent.Bill,
                    testId: "billing-control-stages-billing-".concat(service === null || service === void 0 ? void 0 : service.id),
                    "data-reason": nonBillableReason || '',
                    disabled: nonBillableReason != null,
                    tooltip: nonBillableReason != null ? {
                        placement: 'top',
                        title: nonBillableReasonToTooltip[nonBillableReason]
                    } : undefined,
                    onClick: ()=>{
                        if (!lastBilledStageServiceItem) return;
                        overlayContext.showModal({
                            biName: 'bill_client_modal',
                            closeOnClickOutside: true,
                            closeOnEscapeKey: true,
                            content: (param)=>{
                                let { dismissModal } = param;
                                return /*#__PURE__*/ _jsx(BillClientModal, {
                                    dismissModal: dismissModal,
                                    defaultItem: lastBilledStageServiceItem,
                                    manualServicesBilling: manualServices,
                                    invoiceDateInfo: invoiceDateInfo,
                                    relationshipId: agreementId,
                                    totalCredits: totalCredits,
                                    earliestBillableDate: earliestBillableDate,
                                    controlData: controlData
                                });
                            }
                        });
                    },
                    children: "Bill"
                })
            })
        ]
    });
}
